const specialties = {
  specialtiesList: "تخصصات",
  list: {
    relatedCatiegories: "الفئات التابعة لها",
    addedServices: "الخدمات المضافة",
    search: "ابحث عن تخصص",
    noDataSubTitle: "لا توجد تخصصات لعرضها حتى الآن",
    noDataDescription: "ابدأ الآن بإضافة تخصص",
    createSpecialtiesButton: "إضافة تخصص جديد",
  },
  addSpecialty: {
    title: "أضف تخصصات جديدة",
    labels: {
      enTitle: "الاسم بالانجليزية",
      arTitle: "الاسم بالعربية",
      category: "الفئة",
    },
    placeholders: {
      enTitle: "أدخل اسم التخصص بالانجليزية",
      arTitle: "أدخل اسم التخصص بالعربية",
      category: "اختر من الفئات",
    },
  },
  editSpecialty: {
    title: "تعديل التخصص",
    labels: {
      edit: "حفظ",
    },
  },
  deleteSpecialty: {
    title: "حذف التخصص",
    deleteConfirmationMsg: "هل أنت متأكد من حذف هذا التخصص ؟ ",
  },
  viewSpecialty: {
    title: "تفاصيل التخصص",
    noCategories: "لا توجد فئات",
    noServices: "لم يتم إضافة خدمات لهذا التخصص",
    addedByProvider: "إضافة بواسطة المزود",
  },
};

export default specialties;
